export default "__VITE_ASSET__D3fpmJu6__";